// extracted by mini-css-extract-plugin
export default {"banner_container":"aboutUs_banner_container__xcq5E","banner":"aboutUs_banner__88ayO"};